import axios from '@/core/axios';
import { Task } from './tasks.types';

export class TasksService {
  new(): Promise<Task> {
    return axios.get<Task>(`/tasks/new`).then(resp => resp?.data);
  }
  get(device_id: number, repair_location: string, with_cancel: boolean): Promise<Task[]> {
    if (!device_id) throw new Error('Missing device_id in get task');
    return axios
      .post<Task[]>(`/tasks/${device_id}/list`, { repair_location: repair_location, with_cancel: with_cancel })
      .then(resp => resp?.data);
  }

  async getConf(match_id: number, repair_location: string, with_cancel: boolean): Promise<Task[]> {
    if (!match_id) throw new Error('Missing device_id in get task');

    const resp = await axios.post<Task[]>(`/tasks/get_conf`, {
      match_id: match_id,
      repair_location: repair_location,
      with_cancel: with_cancel
    });
    return resp?.data;
  }

  async create(task: Task): Promise<Task> {
    if (!task) throw new Error('Missing task in create task');

    const resp = await axios.post<Task>(`/tasks/create`, task);
    return resp?.data;
  }

  async update(task: Partial<Task>): Promise<Task> {
    if (!task) throw new Error('Missing task in update task');

    const resp = await axios.put<Task>(`/tasks/update`, task);
    return resp?.data;
  }

  delete(task_id: number): Promise<Task> {
    if (!task_id) throw new Error('Missing task_id in delete task');
    return axios.delete<Task>(`/tasks/${task_id}`).then(resp => resp?.data);
  }

  validate(task: Task): Promise<Task> {
    if (!task.id) throw new Error('Missing task_id in validate task');
    return axios.post<Task>(`/tasks/validate`, task).then(resp => resp?.data);
  }
}

export const tasksService = new TasksService();
